import apiCompetitions from '@/api/competition'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null
}

export const mutationTypes = {
  updateCompetitionStart: '[update competition] Update competition start',
  updateCompetitionSuccess: '[update competition] Update competition success',
  updateCompetitionFailure: '[update competition] Update competition failure',

  getCompetitionStart: '[update competition] Get competition start',
  getCompetitionSuccess: '[update competition] Get competition success',
  getCompetitionFailure: '[update competition] Get competition failure'
}

export const actionTypes = {
  updateCompetition: '[update competition] Update competition',
  getCompetition: '[update competition] Get competition'
}

const mutations = {
  [mutationTypes.updateCompetitionStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.updateCompetitionSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateCompetitionFailure](state, payload) {
    state.error = payload || 'error'
    state.isSubmitting = false
  },

  [mutationTypes.getCompetitionStart](state) {
    state.isLoading = true
    state.data = null
  },

  [mutationTypes.getCompetitionSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getCompetitionFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.updateCompetition](context, {competitionInput}) {
    context.commit(mutationTypes.updateCompetitionStart)
    return new Promise(resolve => {
      apiCompetitions
        .updateCompetition(competitionInput)
        .then(response => {
          context.commit(mutationTypes.updateCompetitionSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateCompetitionFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getCompetition](context, {id}) {
    context.commit(mutationTypes.getCompetitionStart)
    return new Promise(resolve => {
      apiCompetitions
        .getCompetition(id)
        .then(response => {
          context.commit(mutationTypes.getCompetitionSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getCompetitionFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
